import { Select, Selection, SelectItem } from '@nextui-org/react'
import { cm } from '~/utils/utils'

interface SelectProps {
  className?: string
  placeholder?: string
  ariaLabel?: string
  size?: 'sm' | 'md' | 'lg'
  items: { key: string; label: string }[]
  selectedKeys?: string[]
  onSelectionChange?: (keys: Selection) => void
  disabled?: boolean
  label?: string
  startContents?: React.ReactNode[]
  triggerPadding?: string
  fontSize?: string
  listProps?: {
    topContent?: React.ReactNode
  }
}

export function CurieSelect({
  className,
  items,
  ariaLabel,
  placeholder,
  size = 'sm',
  selectedKeys = ['Indexing...'],
  onSelectionChange = () => {},
  disabled = false,
  label = '',
  startContents,
  triggerPadding = '',
  fontSize = 'text-xs',
  listProps
}: SelectProps) {
  ariaLabel = ariaLabel || placeholder
  return (
    <Select
      labelPlacement='outside'
      radius='none'
      size={size}
      label={label}
      placeholder={placeholder}
      aria-label={ariaLabel}
      className={className}
      defaultSelectedKeys={selectedKeys}
      selectedKeys={selectedKeys}
      onSelectionChange={onSelectionChange}
      isDisabled={disabled}
      classNames={{
        base: 'w-full border-box dark:bg-medium6 pb-4 px-[1px]',
        trigger: cm(
          'w-full bg-white dark:bg-medium6 data-[hover=true]:bg-light3 dark:data-[hover=true]:bg-medium2',
          'shadow-sm ring-1 ring-[#d4dce2] group-data-[focus=true]:bg-transparent rounded-xl',
          triggerPadding
        ),
        innerWrapper: 'truncate',
        popoverContent: cm('rounded-xl dark:bg-medium6', fontSize),
        value: fontSize
      }}
      listboxProps={listProps}
    >
      {items.map((item, index) => (
        <SelectItem
          key={item.key || index}
          className='caret-transparent no-close'
          startContent={startContents ? startContents[index] : null}
          classNames={{
            base: 'break-all'
          }}
        >
          {item.label}
        </SelectItem>
      ))}
    </Select>
  )
}
